/**
 * Returns list of values for options selected
 * @param {Array} names
 * @param {Array} list
 * @returns result
 */
export const getValuesFromOptions = (names, list) => {
  const result = [];
  list?.map(obj => {
    if (names.includes(obj.name)) {
      result.push(obj.value);
    }
  });
  return result;
};
